"use client";

import { FilterSearch } from "@/features/filters/components/filter-search";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";
import { type HTMLAttributes } from "react";

type BlogSearchProps = HTMLAttributes<HTMLDivElement>;

export const BlogSearch = ({ className, ...props }: BlogSearchProps) => {
  const t = useTranslations("blog");

  return (
    <div className={cn("relative flex lg:self-start", className)} {...props}>
      <FilterSearch
        className="lg:w-76 w-full"
        placeholder={t("filters.search.placeholder")}
        input={{ className: "border h-12 bg-white w-full " }}
      />
    </div>
  );
};
